export const STOCK_SELECTION_COMPLETED = 'STOCK_SELECTION_COMPLETED';
